module.exports = new __parcel__URL__("incidents-task-two-illustration-dark.2cc09514.png").toString();